import { render } from "./Donut_chart.vue?vue&type=template&id=5ee75d26"
import script from "./Donut_chart.vue?vue&type=script&lang=js"
export * from "./Donut_chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__